"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NavLink", {
    enumerable: true,
    get: function() {
        return NavLink;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _endusericons = require("../../end-user-icons");
const _adminicons = require("../../admin-icons");
const _Theme = require("../../contexts/Theme");
const _NavContext = require("../../contexts/NavContext");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const NavLink = /*#__PURE__*/ (0, _react.forwardRef)((param, ref)=>{
    let { children, noMargin = false, icon: Icon, actionButton, ...props } = param;
    const { fontWeight } = (0, _react.useContext)(_NavContext.NavContext);
    const { spacers, colors, borderRadius, isAdmin } = (0, _Theme.useTheme)();
    return /*#__PURE__*/ _react.default.createElement("a", {
        ref: ref,
        role: "option",
        ...props,
        className: _style.default.dynamic([
            [
                "449da7a484db6cdf",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    fontWeight === "light" ? "initial" : "500",
                    spacers.s2,
                    colors.grayscale_5,
                    spacers.s3,
                    colors.primary,
                    spacers.s3,
                    colors.medium,
                    spacers.s3
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "dropdownitem")
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "449da7a484db6cdf",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    fontWeight === "light" ? "initial" : "500",
                    spacers.s2,
                    colors.grayscale_5,
                    spacers.s3,
                    colors.primary,
                    spacers.s3,
                    colors.medium,
                    spacers.s3
                ]
            ]
        ])
    }, Icon != null && /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "449da7a484db6cdf",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    fontWeight === "light" ? "initial" : "500",
                    spacers.s2,
                    colors.grayscale_5,
                    spacers.s3,
                    colors.primary,
                    spacers.s3,
                    colors.medium,
                    spacers.s3
                ]
            ]
        ]) + " " + "icon"
    }, /*#__PURE__*/ _react.default.createElement(Icon, {
        size: 16,
        className: _style.default.dynamic([
            [
                "449da7a484db6cdf",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    fontWeight === "light" ? "initial" : "500",
                    spacers.s2,
                    colors.grayscale_5,
                    spacers.s3,
                    colors.primary,
                    spacers.s3,
                    colors.medium,
                    spacers.s3
                ]
            ]
        ])
    })), children), props.target === "_blank" && /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "449da7a484db6cdf",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    fontWeight === "light" ? "initial" : "500",
                    spacers.s2,
                    colors.grayscale_5,
                    spacers.s3,
                    colors.primary,
                    spacers.s3,
                    colors.medium,
                    spacers.s3
                ]
            ]
        ]) + " " + "external"
    }, actionButton != null && /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "449da7a484db6cdf",
                [
                    spacers.s3,
                    borderRadius,
                    noMargin ? "none" : "0 ".concat(spacers.s3),
                    fontWeight === "light" ? "initial" : "500",
                    spacers.s2,
                    colors.grayscale_5,
                    spacers.s3,
                    colors.primary,
                    spacers.s3,
                    colors.medium,
                    spacers.s3
                ]
            ]
        ]) + " " + "actions"
    }, actionButton), isAdmin ? /*#__PURE__*/ _react.default.createElement(_adminicons.RiShareBoxLine, {
        size: 12
    }) : /*#__PURE__*/ _react.default.createElement(_endusericons.BsBoxArrowUpRight, {
        size: 12
    })), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "449da7a484db6cdf",
        dynamic: [
            spacers.s3,
            borderRadius,
            noMargin ? "none" : "0 ".concat(spacers.s3),
            fontWeight === "light" ? "initial" : "500",
            spacers.s2,
            colors.grayscale_5,
            spacers.s3,
            colors.primary,
            spacers.s3,
            colors.medium,
            spacers.s3
        ]
    }, "a.__jsx-style-dynamic-selector{padding:".concat(spacers.s3, ";cursor:pointer;text-align:left;-webkit-border-radius:").concat(borderRadius, ";-moz-border-radius:").concat(borderRadius, ";border-radius:").concat(borderRadius, ";margin:").concat(noMargin ? "none" : "0 ".concat(spacers.s3), ";font-weight:").concat(fontWeight === "light" ? "initial" : "500", ";font-size:12px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;text-decoration:none;margin-bottom:").concat(spacers.s2, ";overflow:hidden}a.__jsx-style-dynamic-selector:hover{background:").concat(colors.grayscale_5, "}div.__jsx-style-dynamic-selector{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;word-break:break-word}.icon.__jsx-style-dynamic-selector{margin-right:").concat(spacers.s3, ";color:").concat(colors.primary, "}.external.__jsx-style-dynamic-selector{-webkit-box-flex:0;-webkit-flex:0;-moz-box-flex:0;-ms-flex:0;flex:0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;margin-left:").concat(spacers.s3, ";color:").concat(colors.medium, ";opacity:0}a.__jsx-style-dynamic-selector:hover .external.__jsx-style-dynamic-selector{opacity:1}.actions.__jsx-style-dynamic-selector{padding-right:").concat(spacers.s3, ";display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex}")));
});
NavLink.displayName = "NavLink";

//# sourceMappingURL=NavLink.js.map